export enum ApiSuccessIndicationEnum {
    Success = 'J',
    Error = 'N',
}
